import { Component, MasterPageDefinition } from '@wix/thunderbolt-becky-types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'

export const accessibilityStyle = createCssCompNode('accessibility', 'accessibilityStyle', {
	getDependencies: (component: Component, refs: FeatureRefs<'accessibility'>) => {
		return {
			experiments: envRefs.experiments,
			componentData:
				component.type === 'Document'
					? refs.dataQuery<MasterPageDefinition['data']>(component.dataQuery!)
					: null,
		}
	},

	toViewItem: (__: unknown, deps: { componentData?: any; experiments: any }) => {
		// For all components except the master page, we don't want to render the accessibility style

		return {
			useOutlineFocusRing: deps?.experiments['specs.thunderbolt.useOutlineFocusRing'],
			visualFocusDisabled: deps?.componentData?.accessibilitySettings?.visualFocusDisabled === true,
		}
	},
})
